

















import BaseComponent from "@/asdcom/BaseComponent";
import { Prop, Component, Watch } from "vue-property-decorator";
import { IClaimSummaryLabelValue } from "./claim-summary-section.vue";


@Component
export default class ClaimSummarySectionItem extends BaseComponent {
  @Prop()
  viewModel: Array<IClaimSummaryLabelValue>;
}
